
// We can do this since nfc_tags are unique
const getNfcTagIdByName = (nfcs, nfcTagName) => nfcs.find(nfc => nfc.tag === nfcTagName).id;

export default getNfcTagIdByName;
